/** 登录接口 */
export const LoginApi = '/app/promotion/prom_login.cgi';
/** 缓存统一前缀，写入方*/
export const CACHE_KEY_PREFIX = 'WPHK_ACT_BASE';
/** 重定向次数记录key */
export const REDIRECT_TAG = `${CACHE_KEY_PREFIX}#LOGIN_TIMES`;
/** 最近一次重定向时间 */
export const CACHE_TIME = `${CACHE_KEY_PREFIX}#LOGIN_CACHE_TIME`;
